var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "PriceDiscountTransaction" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          disabled: _vm.insertReadonly.StatusId,
                          type: "number",
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("get.PriceDiscountTransaction.general"),
                    active: !_vm.developmentMode
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TciBreak1Id",
                            error: _vm.$v.form.TciBreak1Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "TCI_BREAKDOWN",
                              disabled: _vm.insertReadonly.TciBreak1Id,
                              label: "Label"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TciBreak1Id", $event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerId",
                            error: _vm.$v.form.CustomerId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.CustomerId,
                              url:
                                "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                              searchable: true,
                              "custom-option": true,
                              label: "Description1",
                              "or-condition-fields":
                                "Code,Description1,CommercialTitle",
                              "is-customer": true
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CustomerId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.customer,
                              callback: function($$v) {
                                _vm.customer = $$v
                              },
                              expression: "customer"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TransactionDate",
                            error: _vm.$v.form.TransactionDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.TransactionDate
                            },
                            model: {
                              value: _vm.form.TransactionDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TransactionDate", $$v)
                              },
                              expression: "form.TransactionDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TransactionTime",
                            error: _vm.$v.form.TransactionTime
                          }
                        },
                        [
                          _c("NextTimePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.TransactionTime
                            },
                            model: {
                              value: _vm.form.TransactionTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TransactionTime", $$v)
                              },
                              expression: "form.TransactionTime"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DiscountReasonId",
                            error: _vm.$v.form.DiscountReasonId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.DiscountReasonId,
                              url:
                                "VisionNextDiscount/api/DiscountReason/Search",
                              label: "Description1"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "DiscountReasonId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PriceDiscountAmount",
                            error: _vm.$v.form.PriceDiscountAmount
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.PriceDiscountAmount
                            },
                            model: {
                              value: _vm.form.PriceDiscountAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "PriceDiscountAmount", $$v)
                              },
                              expression: "form.PriceDiscountAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CurrencyId",
                            error: _vm.$v.form.CurrencyId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.CurrencyId,
                              label: "Description1",
                              url: "VisionNextSystem/api/SysCurrency/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CurrencyId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.currencyLabel,
                              callback: function($$v) {
                                _vm.currencyLabel = $$v
                              },
                              expression: "currencyLabel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BudgetId",
                            error: _vm.$v.form.BudgetId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: !_vm.form.UseBudget,
                              label: "CustomerDesc",
                              source: _vm.budgets
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "BudgetId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.budget,
                              callback: function($$v) {
                                _vm.budget = $$v
                              },
                              expression: "budget"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApproveStateId",
                            error: _vm.$v.form.ApproveStateId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "APPROVE_STATE",
                              disabled: _vm.insertReadonly.ApproveStateId,
                              label: "Label"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ApproveStateId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.approveState,
                              callback: function($$v) {
                                _vm.approveState = $$v
                              },
                              expression: "approveState"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ErpCode",
                            error: _vm.$v.form.ErpCode
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.ErpCode
                            },
                            model: {
                              value: _vm.form.ErpCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ErpCode", $$v)
                              },
                              expression: "form.ErpCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ExpirationDate",
                            error: _vm.$v.form.ExpirationDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.ExpirationDate
                            },
                            model: {
                              value: _vm.form.ExpirationDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ExpirationDate", $$v)
                              },
                              expression: "form.ExpirationDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BeginDate",
                            error: _vm.$v.form.BeginDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.insertReadonly.BeginDate },
                            model: {
                              value: _vm.form.BeginDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "BeginDate", $$v)
                              },
                              expression: "form.BeginDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Genexp1",
                            error: _vm.$v.form.Genexp1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Genexp1
                            },
                            model: {
                              value: _vm.form.Genexp1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Genexp1", $$v)
                              },
                              expression: "form.Genexp1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "GainTypeId",
                            error: _vm.$v.form.GainTypeId
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.GainTypeId
                            },
                            model: {
                              value: _vm.GainTypeName,
                              callback: function($$v) {
                                _vm.GainTypeName = $$v
                              },
                              expression: "GainTypeName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UseBudget",
                            error: _vm.$v.form.UseBudget
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled:
                                !_vm.form.CustomerId ||
                                _vm.form.CustomerId === 0
                            },
                            model: {
                              value: _vm.useBudget,
                              callback: function($$v) {
                                _vm.useBudget = $$v
                              },
                              expression: "useBudget"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78ba8760", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ba8760","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PriceDiscountTransaction/insert.vue
// module id = null
// module chunks = 